import React, { FC } from 'react';
import { PageSection, Tab } from 'components';
import { useTranslation } from 'react-i18next';
import {
    Container,
    Title,
    SecondaryBlocksContainer,
} from '../../../for-businesses/components/constructor/styled';
import { CSSObject } from 'styled-components';
import { MainBlock } from 'containers/pages/for-businesses/components/constructor/MainBlock';
import { SecondaryBlock } from 'containers/pages/for-businesses/components/constructor/SecondaryBlock';

const sectionConfig = {
    CWrap: {
        css: {
            paddingTop: 0,
            paddingBottom: 70,

            '@media(max-width: 1279px)': {
                paddingTop: 110,
            },

            '@media(max-width: 1023px)': {
                paddingTop: 0,
                paddingBottom: 27,
            },
        },
    },
    ContentArea: {
        css: {
            display: 'block',
            position: 'relative',
        },
    },
};

interface ConstructorProps {
    bgImagePath: string;
    title: string;
    bgStyles?: CSSObject;
}

export const Constructor: FC<ConstructorProps> = ({
    bgImagePath,
    title,
    bgStyles,
}) => {
    const { t } = useTranslation('pages/for-schools-and-colleges');

    const tabs = {
        tabs: [
            {
                key: 'tech',
                isActive: true,
                body: (
                    <>
                        <MainBlock
                            config={{
                                title: t('constructor-title-1'),
                                imagePath:
                                    '/assets/images/bussiness/school-girl-paptop2.webp',
                                link: '/assets/files/open-lesson-materials.zip',
                                downloadLink: {
                                    fileName:
                                        'Методические материалы для школ_Лаборатория Касперского.zip',
                                },
                                imageStyles: {
                                    backgroundPositionX: '101%',
                                    backgroundPositionY: '29%',
                                    backgroundSize: '64%',
                                    '@media(max-width: 1023px)': {
                                        backgroundPosition: '50%',
                                    },
                                },
                                buttonLabel: t('download-all'),
                            }}
                        />
                        <SecondaryBlocksContainer>
                            <SecondaryBlock
                                config={{
                                    title: t('constructor-title-4'),
                                    subtitle: t('constructor-subtitle-4'),
                                    downloadLink: {
                                        fileName: 'Социальная инженерия',
                                    },
                                    link: '/assets/files/social-engineering.zip',
                                    buttonLabel: t('download'),
                                }}
                            />
                            <SecondaryBlock
                                config={{
                                    title: t('constructor-title-5'),
                                    subtitle: t('constructor-subtitle-5'),
                                    link: '/assets/files/steganography.zip',
                                    downloadLink: {
                                        fileName: 'Стеганография',
                                    },
                                    buttonLabel: t('download'),
                                }}
                            />
                        </SecondaryBlocksContainer>
                        <MainBlock
                            config={{
                                withoutGradient: true,
                                title: t('constructor-title-6'),
                                subtitle: t('constructor-subtitle-6'),
                                link: '/assets/files/password.zip',
                                downloadLink: {
                                    fileName: 'Надежность пароля.zip',
                                },
                                imageStyles: {
                                    backgroundColor: '#f4f7fa',
                                },
                                buttonLabel: t('download'),
                            }}
                        />
                    </>
                ),
                title: <span>{t('constructor-books')}</span>,
            },
            {
                key: 'communication',
                body: (
                    <MainBlock
                        config={{
                            title: t('constructor-title-2'),
                            subtitle: t('constructor-subtitle-2'),
                            imagePath:
                                '/assets/images/bussiness/school-girl-laptop.webp',
                            link: '/assets/files/infosec.pdf',
                            downloadLink: {
                                fileName:
                                    'Информационная безопасность. Учебное пособие для средней и старшей школы.pdf',
                            },
                            imageStyles: {
                                backgroundSize: '75%',
                                backgroundPositionX: '457px',
                                backgroundPositionY: '25%',
                                '@media(max-width: 1023px)': {
                                    backgroundPositionX: '70px',
                                },
                            },
                            buttonLabel: t('download'),
                        }}
                    />
                ),
                title: <span>{t('constructor-communication')}</span>,
            },
            {
                key: 'cyber',
                body: (
                    <MainBlock
                        config={{
                            title: t('constructor-title-3'),
                            subtitle: t('constructor-subtitle-3'),
                            imagePath:
                                '/assets/images/bussiness/school-laptop.webp',
                            link: 'https://lms.ficto.ru/local/crw/course.php?id=61',
                            imageStyles: {
                                backgroundSize: '70%',
                                backgroundPositionX: '121%',
                                backgroundPositionY: '34%',
                                '@media(max-width: 1023px)': {
                                    backgroundPositionX: 'right',
                                },
                            },
                            buttonLabel: t('learn-more'),
                            blank: true,
                        }}
                    />
                ),
                title: <span>{t('constructor-cyber')}</span>,
            },
        ],
        styles: {
            textColor: '#fff',
            rootStyles: `
                    border-radius: 10px 10px 0px 0px;
            `,
            menuStyles:
                'padding: 0; gap: 40px; padding: 0 70px; justify-content: center;' +
                '@media only screen and (max-width: 1023px) { flex-direction: row !important; border-bottom: none !important; gap: 10px !important; padding: 0; flex-wrap: wrap; justify-content: flex-start; }',
            menuItemStyles:
                'padding: 20px 0; font-size: 21px; line-height: 24px; font-weight: 300; &:after { background: #3DE8CA; bottom: -2px; }' +
                '@media only screen and (max-width: 1023px) { &:after { display: none; }; font-size: 16px; line-height: 14px; padding: 5px 12px; background: #ECEFF3; color: #000000; white-space: nowrap; ' +
                'border-radius: 24px; width: auto !important; &.is-active { padding-right: 26px; background: linear-gradient(45deg, #3DE8CA 38.74%, #33FF77 100%); &:before { content: "✖"; position: absolute; right: 10px; top: 50%; transform: translateY(-50%); font-size: 12px; }; } }',
            bodyStyles: 'padding: 40px 0 0 0;',
        },
    };

    return (
        <Container bgImagePath={bgImagePath} bgStyles={bgStyles}>
            <PageSection config={sectionConfig}>
                <Title>{title}</Title>
                <Tab {...tabs} />
            </PageSection>
        </Container>
    );
};
